import { createFeature, createReducer, on } from '@ngrx/store';
import { AgentReportModel } from '@shared/data-access/models';
import { AwardsReportAction } from '../actions';

export const featureName = 'awardsReports';

export interface AwardsReportState {
  item: AgentReportModel | null;
}
export const initialState: AwardsReportState = {
  item: null,
};
export const awardsReportFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(AwardsReportAction.loadItemSuccess, (state, prop: { item: AgentReportModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = awardsReportFeature;
